var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronBottom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 7,
    viewBox: "0 0 12 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.72003 6.77998C6.57951 6.92067 6.38887 6.99981 6.19003 6.99998H5.81003C5.61161 6.99768 5.42175 6.91887 5.28003 6.77998L0.150025 1.63998C0.0553694 1.5461 0.00212669 1.4183 0.00212669 1.28498C0.00212669 1.15166 0.0553694 1.02386 0.150025 0.929982L0.860025 0.219982C0.952189 0.125918 1.07834 0.0729102 1.21003 0.0729102C1.34172 0.0729102 1.46786 0.125918 1.56003 0.219982L6.00003 4.66998L10.44 0.219982C10.5339 0.125325 10.6617 0.0720825 10.795 0.0720825C10.9283 0.0720825 11.0561 0.125325 11.15 0.219982L11.85 0.929982C11.9447 1.02386 11.9979 1.15166 11.9979 1.28498C11.9979 1.4183 11.9447 1.5461 11.85 1.63998L6.72003 6.77998Z",
    fill: "#3367CD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronBottom);
export default __webpack_public_path__ + "static/media/chevronBottom.58b210aa.svg";
export { ForwardRef as ReactComponent };